import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from "@/components/ui/dialog"
import { Separator } from "@/components/ui/separator"
import { useCarrinho } from "@/contexts/CarrinhoProvider"
import { CautelaDto } from "@/dtos/BuscarCautelasDisponiveisDto"
import { useEffect, useState } from "react"
import { labelPlural, labelSingular } from "@/utils/copyTituloBilhete"

interface IModalProps {
  cautelas: CautelaDto[]
}

export function ModalVisualizarTitulos(props: IModalProps) {
  const [exibirModal, setExibirModal] = useState(false);
  const { removerCautelaCarrinho } = useCarrinho();
  const [atualizarPagina, setAtualizarPagina] = useState(false);
  const [removendoCarrinho, setRemovendoCarrinho] = useState(0);
  const [cautelas, setCautelas] = useState<CautelaDto[]>([]);

  useEffect(() => {
    setCautelas(props.cautelas);
  }, [])



  async function toggleModal() {
    if (atualizarPagina) {
      window.location.reload();
    }
    setExibirModal(!exibirModal)
  }

  function formatarDezenas(dezenas: string) {
    const dezenasFormatas: number[] = [];

    if (dezenas == null || dezenas == undefined) {
      return [];
    }

    for (let index = 0; index < dezenas.length; index += 2) {
      const dezena = dezenas.slice(index, index + 2);
      dezenasFormatas.push(Number(dezena))
    }

    return dezenasFormatas.map(dezena => `${dezena}`.padStart(2, '0'))
  }

  async function handleRemoverDoCarrinho(idCautela: number) {
    try {
      setRemovendoCarrinho(idCautela)
      await removerCautelaCarrinho(idCautela);
      setCautelas(old => {
        const cautelasFiltradas = old.filter(c => c.IdCautela !== idCautela);

        if (cautelasFiltradas.length === 0) {
          window.location.reload();
        }

        return cautelasFiltradas;
      })

      setAtualizarPagina(true);
    } catch (error) {

    } finally {
      setRemovendoCarrinho(0)
    }
  }

  return (
    <>
      <Button onClick={toggleModal}>Ver {labelPlural()}</Button>

      <Dialog open={exibirModal} onOpenChange={toggleModal}>


        <DialogContent className="min-w-[40%]">
          <DialogTitle className="text-primary-foreground font-semibold text-xl my-2 text-center">
            {labelPlural()} Selecionados
          </DialogTitle>

          <div className="flex flex-col gap-4 ">

            {
              cautelas.map((cautela) => (
                <Card key={cautela.IdCautela} className={removendoCarrinho === cautela.IdCautela ? 'border-2 border-red-600 ' : 'border-2'}>
                  <CardContent className="p-3">
                    <p className="text-primary-foreground font-semibold">{labelSingular()} nº: {cautela.Titulos[0].Numero}</p>

                    <div className="text-primary-foreground font-semibold">Numero da Sorte:&nbsp;
                      <span>{cautela.Titulos.map((titulo) => titulo.NumeroSorte).join(" e ")}</span>
                    </div>

                    <div className="flex flex-col items-center mt-2 gap-2">
                      {
                        cautela.Titulos.map((titulo, i) => (
                          <div key={titulo.IdTitulo} className="my-2">
                            <div className="flex flex-wrap justify-center w-72 select-none">
                              {
                                formatarDezenas(titulo.Dezenas).map((dezena, index) => {
                                  return (
                                    <span key={`${titulo.Dezenas}-${index}`} className="text-center tabular-nums rounded-full h-12 w-12 m-1 p-3 border-2 shadow-md">
                                      {dezena}
                                    </span>
                                  )
                                })
                              }
                            </div>

                            {
                              cautela.Titulos.length > 0 && cautela.Titulos.length !== (i + 1) && (
                                <Separator className="mt-5" />
                              )
                            }
                          </div>
                        ))
                      }
                    </div>

                    <div className="text-center">
                      <Button
                        disabled={removendoCarrinho === cautela.IdCautela}
                        type="button"
                        onClick={() => {
                          handleRemoverDoCarrinho(cautela.IdCautela)
                        }}
                        variant="foreground" className="mt-2">
                        {
                          removendoCarrinho ? 'Removendo do Carrinho.' : 'Remover do Carrinho'
                        }
                      </Button>
                    </div>
                  </CardContent>

                </Card>
              ))
            }
          </div>
          <DialogFooter>
            <Button type="button" onClick={toggleModal} className="m-1">Fechar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}